import React from "react";
import { Search, Filter, ChevronDown } from "lucide-react";

interface CalendarToolbarProps {
  data: {
    viewMode: "today" | "weekly" | "monthly";
  };

  handlers: {
    onViewModeChange: (mode: "today" | "weekly" | "monthly") => void;
  };
}

const CalendarToolbar: React.FC<CalendarToolbarProps> = ({
  data,
  handlers,
}) => {
  const { viewMode } = data;

  const { onViewModeChange } = handlers;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 mb-6">
      <div className="flex items-center justify-between">
        {/* Left */}

        <div className="flex items-center gap-3">
          {/* Search */}

          <div className="relative">
            <Search
              size={16}
              className="
                absolute
                left-3
                top-1/2
                -translate-y-1/2
                text-gray-400
                pointer-events-none
              "
            />

            <input
              placeholder="Search services..."
              className="
                w-64
                pl-9
                pr-4
                py-2.5
                border
                rounded-lg
                outline-none
                focus:ring-2
                focus:ring-indigo-200
              "
            />
          </div>

          {/* Filter */}

          <div className="relative">
            <Filter
              size={16}
              className="
                absolute
                left-3
                top-1/2
                -translate-y-1/2
                text-gray-500
                pointer-events-none
              "
            />

            <ChevronDown
              size={16}
              className="
                absolute
                right-3
                top-1/2
                -translate-y-1/2
                text-gray-500
                pointer-events-none
              "
            />

            <select
              defaultValue="all"
              className="
                appearance-none
                pl-10
                pr-10
                py-2.5
                border
                rounded-lg
                outline-none
                cursor-pointer
                hover:bg-gray-50
                focus:ring-2
                focus:ring-indigo-200
              "
            >
              <option value="all">All Services</option>

              <option value="pending">Pending</option>

              <option value="confirmed">Confirmed</option>

              <option value="inprogress">In Progress</option>

              <option value="completed">Completed</option>

              <option value="cancelled">Cancelled</option>
            </select>
          </div>

          {/* View Mode */}

          <div className="relative">
            <ChevronDown
              size={16}
              className="
                absolute
                right-3
                top-1/2
                -translate-y-1/2
                text-gray-500
                pointer-events-none
              "
            />

            <select
              value={viewMode}
              onChange={(e) =>
                onViewModeChange(
                  e.target.value as "today" | "weekly" | "monthly"
                )
              }
              className="
                appearance-none
                border
                rounded-lg
                px-4
                pr-10
                py-2.5
                outline-none
                cursor-pointer
                hover:bg-gray-50
                focus:ring-2
                focus:ring-indigo-200
              "
            >
              <option value="today">Today</option>

              <option value="weekly">Weekly</option>

              <option value="monthly">Monthly</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarToolbar;